import {Component, Renderer2, OnInit, Inject, OnDestroy} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from './app.config';
import { ThemeService } from './services/theme.service';
import {ActivatedRoute, Router} from "@angular/router";
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'body',
  template: '<div *ngIf="langLoaded"><router-outlet></router-outlet></div>',
})
export class AppComponent implements OnInit, OnDestroy {
  public langLoaded: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private translate: TranslateService,
    private appConfig: AppConfig,
    private theme: ThemeService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    translate.setDefaultLang(this.getDefaultLanguage());
    translate.get('hubtiger').subscribe((res) => {
      this.langLoaded = true;
    });

    this.theme.enableDefault();

    this.checkURLwhiteLabel()

  }

  ngOnInit() {
    // Handle MSAL redirect response
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        console.log('App: MSAL interaction complete');
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  checkURLwhiteLabel(){
    const currentUrl = window.location.hostname;
    if (currentUrl.includes('specific-url')) {
      document.body.classList.add('white-label');
    }

    console.log('currentUrl: ', currentUrl)
    this.theme.getOverrideUrlCss(currentUrl)

  }


  getDefaultLanguage() {
    var browserLanguage = navigator.language.toString();
    var lang = this.appConfig
      .getLanguages()
      .find((x) => x.code == browserLanguage);
    if (lang && lang.value) {
      return this.appConfig.getPartnerType() === 'bicycle'
        ? lang.value.toLowerCase()
        : this.appConfig.getPartnerType() + '/' + lang.value.toLowerCase();
    } else {
      return this.appConfig.getPartnerType() === 'bicycle'
        ? this.appConfig.getLocale()
        : this.appConfig.getPartnerType() + '/' + this.appConfig.getLocale();
    }
  }

}
